export const getResourceIdentifier = (resource, routerStoreContext, resourceStoreContext) => {
  const {
    type,
    getKey
  } = resource;
  const key = getKey(routerStoreContext, resourceStoreContext);
  return `${type}/${key}`;
};
export const getResourceIdentifiers = (resources, routerStoreContext, resourceStoreContext) => resources.map(resource => getResourceIdentifier(resource, routerStoreContext, resourceStoreContext));